import { DIRECTION_FLIGHT, DIRECTION_ARRIVE } from 'components/components/booking/utils/FlightConstants';

class TimetableHelper {
  constructor(flightObject, addressObject) {
    this.flightObject = flightObject;
    this.addressObject = addressObject;
  }

  isFlight() {
    return this.flightObject.direction == DIRECTION_FLIGHT;
  }

  isArrive(flight) {
    return this.flightObject.direction == DIRECTION_ARRIVE;
  }

  getTimetableInfo() {
    var addressValue = this.addressObject.selectedObject && this.addressObject.selectedObject.value;
    var timetables = this.flightObject.timetables;
    var timetable = this.findTimetable(timetables, addressValue);
    if (timetable) {
      return this.getData(timetable, this.flightObject);
    } else {
      return null;
    }
  }

  getData(timetable, flight) {
    if (this.isFlight()) {
      return {
        busStopTime: timetable.departure_time,
        airportTime: timetable.arrival_time
      }
    } else {
      return {
        busStopTime: timetable.arrival_time,
        airportTime: timetable.departure_time
      }
    }
  }

  getRouteAsText() {
    var addressName = this.addressObject.selectedObject && this.addressObject.phrase;
    var data = this.getTimetableInfo();
    var airportName = this.flightObject.airport && this.flightObject.airport.name;
    var busStopTime = '';
    var airportTime = '';
    if (data) {
      busStopTime = data.busStopTime;
      airportTime = data.airportTime;
    }
    if (this.isFlight()) {
      return `${addressName} ${busStopTime} - ${airportName} ${airportTime}`;
    } else {
      return `${airportName} ${airportTime} - ${addressName} ${busStopTime}`;
    }
  }

  findTimetable(timetables, addressValue) {
    if (timetables.length == 0) {
      return null;
    }

    for (var index in timetables) {
      var timetable = timetables[index];
      if (timetable.bus_stop == addressValue) {
        return timetable;
      }
    }
    return null;

  }

}

export default TimetableHelper;
